import { isBefore, isAfter, parseISO } from "date-fns"

export  function isOverlap(a, b) {
    const aStart = format(a.startDate);
    const aEnd = format(a.endDate);
    const bStart = format(b.startDate);
    const bEnd = format(b.endDate);
    function format (date) {
        return typeof date == "string"? 
                    parseISO(date):
                    date
    }
    return !(isBefore(aEnd, bStart) || isAfter(aStart, bEnd));
}